function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'navy-seals': 'url("//hemyelevate.com/cdn/shop/files/camoblue_68x.jpg?v=16705902001565428918")','sunset-strike': 'url("//hemyelevate.com/cdn/shop/files/camoorange_68x.jpg?v=14581419335617292351")','pink-panthers': 'url("//hemyelevate.com/cdn/shop/files/camopink_68x.jpg?v=7029833065124882941")','forest-rangers': 'url("//hemyelevate.com/cdn/shop/files/camogreen_68x.jpg?v=14812446616981991248")','rose-quartz': 'url("//hemyelevate.com/cdn/shop/files/rose_68x.jpg?v=17822953563905111277")','cobalt': 'url("//hemyelevate.com/cdn/shop/files/cobalt_68x.jpg?v=12454445732081073839")','platinum': 'url("//hemyelevate.com/cdn/shop/files/Platinum_68x.jpg?v=1696687428274829395")','ruby': 'url("//hemyelevate.com/cdn/shop/files/ruby_68x.jpg?v=7917802379726270670")','santas-socks': 'url("//hemyelevate.com/cdn/shop/files/santa_68x.jpg?v=12485278647769464488")','mistletoe': 'url("//hemyelevate.com/cdn/shop/files/mistletoe_68x.jpg?v=7017921865227473056")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
